<template>
    <v-card flat>
        <v-card-title class="subheading " style="height:75px">
            <strong>{{reportData.name}}</strong>
            <v-spacer/>
            <v-text-field 
              v-model="search"
              hide-details
              placeholder="Search by Style/Description/Season/ETA/...." 
              />
              <v-spacer/>
            <v-icon small class="red--text">fas fa-pdf</v-icon>
            <v-icon small class="green--text">fas fa-excel</v-icon>
            <v-icon @click="showSortColumns" small class="black--text">fas fa-list</v-icon> &nbsp;
            <v-icon small class="black--text">fas fa-print</v-icon>
            &nbsp;
            <v-icon @click="closeDialog" small class="black--text">fas fa-times</v-icon>
        </v-card-title>
        <hr>
        <v-card-text style="zoom:90%">
              
              <v-data-table
                :headers="reportData.headers"
                :items="reportData.data"
                :search="search"
                 v-model="selected"
                   :pagination.sync="pagination"
                   fixed-header
   
                >
                <template slot="items" slot-scope="props">
                    <tr>
                        <template v-for="(key,index) in props.item">
                            <td>
                                <span v-if="index!='image'"> 
                                {{key}}
                                </span>
                               <span v-if="index=='image'"> 
                                    <v-img @click="showImageDialog(key)" height="64px" width="64px" :src="key" />
                                 
                                </span>
                            </td>
                        </template>
                    </tr>
                </template>
              </v-data-table>
              
        </v-card-text>
        <v-dialog width="40%"    v-model="showDialog" >
            <SortComponent v-if="showSort" :headers="reportData.headers"  v-on:applySort="applySort"/>
        </v-dialog>
        <v-dialog width="50%" v-model="imageDialog" >
             <v-card>
                <v-container
                fluid
                grid-list-md
                >
                <v-img :src="largeImage"/>
                           
                </v-container>
           
            </v-card>
        </v-dialog>
       
    </v-card>
</template>
<script>
import SortComponent from '@/components/SortComponent.vue'
import lodash from 'lodash'

export default {
    components: {
        SortComponent
    },
    props: [
        "reportData"
    ],
    data() {
        return {
            selected: [],
            search:"",
            showSort:false,
            showDialog:false,
            imageDialog:false,
            largeImage:"",
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 1000,
                sortBy: '',
                totalItems: 0,
                rowsPerPageItems: [1, 2, 4, 8, 16]
            },
        }
    },
    created: function() {
        
    },
    mounted: function() {
        reportData.headers[1].fixed=true
        alert('mounted')
    },
    methods: {
        applySort($sortKeys) {
            this.showDialog=false
            this.showSort =false 
            //alert(($sortKeys))
           // this.reportData.data=lodash.sortBy(this.reportData.data, ['ITEM_NUM_DISPLAY', 'SEASON_DESC']);
            this.reportData.data=lodash.sortBy(this.reportData.data, $sortKeys);

        },
        showSortColumns() {
            this.showDialog=true
            this.showSort = true  
        },
        closeDialog() {
            this.$emit('closeDialog')
        },
        showImageDialog($image) {
              this.imageDialog=true
              this.largeImage=$image
        }
    }
}
</script>
<style scoped>
table tbody, table thead
{
    display: block;
}
table tbody 
{
   overflow: auto;
   height: 100px;
}
</style>